import axios from "axios";
import { toast } from "sonner";

// Action Types
export const FETCH_BLOG_POSTS_SUCCESS = "FETCH_BLOG_POSTS_SUCCESS";
export const FETCH_BLOG_POST_SUCCESS = "FETCH_BLOG_POST_SUCCESS";
export const UPDATE_BLOG_POST_SUCCESS = "UPDATE_BLOG_POST_SUCCESS";
export const FETCH_BLOG_POSTS_FAIL = "FETCH_BLOG_POSTS_FAIL";
export const FETCH_BLOG_POST_FAIL = "FETCH_BLOG_POST_FAIL";
export const UPDATE_BLOG_POST_FAIL = "UPDATE_BLOG_POST_FAIL";
export const CLEAR_SELECTED_POST = "CLEAR_SELECTED_POST";
export const CLEAR_ERROR = "CLEAR_ERROR";

// Blog Title Action Types
export const FETCH_BLOG_TITLES_SUCCESS = "FETCH_BLOG_TITLES_SUCCESS";
export const FETCH_BLOG_TITLES_FAIL = "FETCH_BLOG_TITLES_FAIL";
export const UPDATE_BLOG_TITLE_SUCCESS = "UPDATE_BLOG_TITLE_SUCCESS";
export const UPDATE_BLOG_TITLE_FAIL = "UPDATE_BLOG_TITLE_FAIL";
export const DELETE_BLOG_TITLE_SUCCESS = "DELETE_BLOG_TITLE_SUCCESS";
export const DELETE_BLOG_TITLE_FAIL = "DELETE_BLOG_TITLE_FAIL";
export const ADD_BLOG_TITLE_SUCCESS = "ADD_BLOG_TITLE_SUCCESS";
export const ADD_BLOG_TITLE_FAIL = "ADD_BLOG_TITLE_FAIL";

export const PROCESS_ALL_BLOG_TITLES_REQUEST =
    "PROCESS_ALL_BLOG_TITLES_REQUEST";
export const PROCESS_ALL_BLOG_TITLES_SUCCESS =
    "PROCESS_ALL_BLOG_TITLES_SUCCESS";
export const PROCESS_ALL_BLOG_TITLES_FAIL = "PROCESS_ALL_BLOG_TITLES_FAIL";

// Action Creators
export const fetchBlogPosts = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/admin/blog-posts");
        dispatch({
            type: FETCH_BLOG_POSTS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: FETCH_BLOG_POSTS_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(
            error.response?.data?.error || "Failed to fetch blog posts",
            {
                duration: 3000,
            }
        );
    }
};

export const fetchBlogPost = (filename) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/blog-posts/${filename}`);
        dispatch({
            type: FETCH_BLOG_POST_SUCCESS,
            payload: { filename, content: response.data.content },
        });
    } catch (error) {
        dispatch({
            type: FETCH_BLOG_POST_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(
            error.response?.data?.error || "Failed to fetch blog post",
            {
                duration: 3000,
            }
        );
    }
};

export const updateBlogPost =
    ({ filename, content }) =>
    async (dispatch) => {
        try {
            const response = await axios.put(
                `/api/admin/blog-posts/${filename}`,
                {
                    content,
                }
            );
            dispatch({
                type: UPDATE_BLOG_POST_SUCCESS,
                payload: { filename, content, message: response.data.message },
            });
            toast.success(
                response.data.message || "Blog post updated successfully",
                {
                    duration: 3000,
                }
            );
        } catch (error) {
            dispatch({
                type: UPDATE_BLOG_POST_FAIL,
                payload: error.response?.data?.error || error.message,
            });
            toast.error(
                error.response?.data?.error || "Failed to update blog post",
                {
                    duration: 3000,
                }
            );
        }
    };

export const clearSelectedPost = () => ({
    type: CLEAR_SELECTED_POST,
});

export const clearError = () => ({
    type: CLEAR_ERROR,
});

// Blog Title Action Creators
export const fetchBlogTitles = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/admin/blog-titles");
        dispatch({
            type: FETCH_BLOG_TITLES_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: FETCH_BLOG_TITLES_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(
            error.response?.data?.error || "Failed to fetch blog titles",
            {
                duration: 3000,
            }
        );
    }
};

export const updateBlogTitle = (titleId, status) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/admin/blog-titles/${titleId}`, {
            status,
        });
        dispatch({
            type: UPDATE_BLOG_TITLE_SUCCESS,
            payload: { id: titleId, status, message: response.data.message },
        });
        toast.success(
            response.data.message || "Blog title status updated successfully",
            {
                duration: 3000,
            }
        );
    } catch (error) {
        dispatch({
            type: UPDATE_BLOG_TITLE_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(
            error.response?.data?.error || "Failed to update blog title status",
            {
                duration: 3000,
            }
        );
    }
};

export const deleteBlogTitle = (titleId) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `/api/admin/blog-titles/${titleId}`
        );
        dispatch({
            type: DELETE_BLOG_TITLE_SUCCESS,
            payload: { id: titleId, message: response.data.message },
        });
        toast.success(
            response.data.message || "Blog title deleted successfully",
            {
                duration: 3000,
            }
        );
        // Refresh the blog titles list after deletion
        dispatch(fetchBlogTitles());
    } catch (error) {
        dispatch({
            type: DELETE_BLOG_TITLE_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(
            error.response?.data?.error || "Failed to delete blog title",
            {
                duration: 3000,
            }
        );
    }
};

export const addBlogTitle = (blogTitleData) => async (dispatch) => {
    try {
        const response = await axios.post(
            "/api/admin/blog-titles",
            blogTitleData
        );
        dispatch({
            type: ADD_BLOG_TITLE_SUCCESS,
            payload: response.data,
        });
        toast.success(
            response.data.message || "Blog title added successfully",
            {
                duration: 3000,
            }
        );
        // Refresh the blog titles list after adding
        dispatch(fetchBlogTitles());
    } catch (error) {
        dispatch({
            type: ADD_BLOG_TITLE_FAIL,
            payload: error.response?.data?.error || error.message,
        });
        toast.error(error.response?.data?.error || "Failed to add blog title", {
            duration: 3000,
        });
    }
};

export const processAllPendingBlogTitles = () => async (dispatch) => {
    dispatch({ type: PROCESS_ALL_BLOG_TITLES_REQUEST });

    try {
        const response = await axios.post("/api/admin/blog-titles/process-all");
        dispatch({ type: PROCESS_ALL_BLOG_TITLES_SUCCESS });
        toast.success(response.data.message);
        // Refresh the blog titles list after starting the process
        dispatch(fetchBlogTitles());
    } catch (error) {
        const errorMessage =
            error.response?.data?.error || "Failed to process blog titles";
        dispatch({ type: PROCESS_ALL_BLOG_TITLES_FAIL, payload: errorMessage });
        toast.error(errorMessage);
    }
};

export const crawlURL = (url) => async (dispatch) => {
    try {
        console.log("Making API call to crawl URL:", url);
        const response = await axios.post("/api/admin/crawl-url", { url });
        console.log("Crawl API response:", response.data);
        return response.data;
    } catch (error) {
        console.error("API error response:", error.response?.data);
        throw new Error(error.response?.data?.error || "Failed to start crawl");
    }
};
